<template>
  <el-dialog
    title="设置包裹信息"
    :visible.sync="visible"
    append-to-body
    width="380px"
    :close-on-press-escape="false"
    @closed="handleClosed">
    <el-form
      ref="ruleForm"
      :rules="rules"
      label-width="80px"
      :model="orderInfo">
      <el-form-item label="发货单号:">
        {{ orderInfo.code }}
      </el-form-item>
      <el-form-item label="物流模板:">
        {{ orderInfo.expressCode | expressName() }}
      </el-form-item>
      <el-form-item
        label="体积:"
        prop="volume">
        <el-input-number
          v-model="orderInfo.volume"
          style="width: 200px"
          :precision="3"
          :min="0">
        </el-input-number>&nbsp;&nbsp;立方米
      </el-form-item>
      <el-form-item
        label="重量:"
        prop="weight">
        <el-input-number
          v-model="orderInfo.weight"
          style="width: 200px"
          :precision="3"
          :min="0">
        </el-input-number>&nbsp;&nbsp;公斤
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button
        :loading="loading"
        @click="toggleModal(false)">取 消</el-button>
      <el-button
        type="primary"
        :loading="loading"
        @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>

</template>
<script>
export default {
  name: 'SetWeightModal',
  props: {
    callback: {
      type: Function
    }
  },
  data() {
    return {
      loading: false,
      visible: false,
      orderInfo: {
        sendOrderId: null,
        volume: 0,
        weight: 0
      },
      rules: {
        volume: [
          { required: true, message: '请输入体积', trigger: 'blur' }
        ],
        weight: [
          { required: true, message: '请输入重量', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.orderInfo.sendOrderId = null
      this.orderInfo.volume = 0
      this.orderInfo.weight = 0
    },
    fetch(row) {
      this.orderInfo = {
        ...this.orderInfo,
        ...row
      }
      this.toggleModal(true)
    },
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.loading = true
          this.$store.dispatch('outstock/setweightandvolume', {
            payload: this.orderInfo,
            success: () => {
              this.toggleModal(false)
              this.callback && this.callback()
              this.loading = false
            },
            fail: () => {
              this.loading = false
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped></style>
